import * as React from 'react';
import { Page } from '~/components/main-page/main-page';

const MainPage: React.FC = () => <Page />;

export default MainPage;
